import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
// Pages
import { Home } from './pages/Home';
import { Bedrijfswaardering } from './pages/Bedrijfswaardering';
import { Werkwijze } from './pages/Werkwijze';
import { Kennisbank } from './pages/Kennisbank';
import { BlogPost } from './pages/BlogPost';
import { Adviseurs } from './pages/Adviseurs';
import { AdviseurDetail } from './pages/AdviseurDetail';
import { OverOns } from './pages/OverOns';
import { Contact } from './pages/Contact';
import { Cases } from './pages/Cases';
import { CaseDetail } from './pages/CaseDetail';
export function App() {
  return <Router data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />

          {/* Money Pages */}
          <Route path="/bedrijfswaardering" element={<Bedrijfswaardering data-id="element-6" />} data-id="element-5" />
          <Route path="/bedrijfswaardering-verkoop" element={<Bedrijfswaardering data-id="element-8" />} data-id="element-7" />
          <Route path="/bedrijfswaardering-overname" element={<Bedrijfswaardering data-id="element-10" />} data-id="element-9" />
          <Route path="/bedrijfswaardering-scheiding" element={<Bedrijfswaardering data-id="element-12" />} data-id="element-11" />
          <Route path="/bedrijfswaardering-conflict" element={<Bedrijfswaardering data-id="element-14" />} data-id="element-13" />
          <Route path="/bedrijfswaardering-interne-overdracht" element={<Bedrijfswaardering data-id="element-16" />} data-id="element-15" />

          {/* Other Core Pages */}
          <Route path="/werkwijze" element={<Werkwijze data-id="element-18" />} data-id="element-17" />
          <Route path="/over-ons" element={<OverOns data-id="element-20" />} data-id="element-19" />
          <Route path="/contact" element={<Contact data-id="element-22" />} data-id="element-21" />

          {/* Cases */}
          <Route path="/cases" element={<Cases data-id="element-24" />} data-id="element-23" />
          <Route path="/cases/:slug" element={<CaseDetail data-id="element-26" />} data-id="element-25" />

          {/* Kennisbank (SEO Hub) */}
          <Route path="/kennisbank" element={<Kennisbank data-id="element-28" />} data-id="element-27" />
          <Route path="/kennisbank/:cluster" element={<Kennisbank data-id="element-30" />} data-id="element-29" />
          <Route path="/kennisbank/:cluster/:slug" element={<BlogPost data-id="element-32" />} data-id="element-31" />

          {/* Adviseurs */}
          <Route path="/adviseurs" element={<Adviseurs data-id="element-34" />} data-id="element-33" />
          <Route path="/adviseurs/:slug" element={<AdviseurDetail data-id="element-36" />} data-id="element-35" />
        </Routes>
      </Layout>
    </Router>;
}